import { ImplementKeys } from './Parameters';
import VueI18n from '../i18n';

// static definitions for the mission and tool types and their labels to be reused by the front end
// this is a front-end only issue with how Exxact defines missions, tools, implements in the UI
export default class MissionToolTypes {
  static missionTypes = [
    { text: VueI18n.t('views.missions.spraying_mission') as string, value: ImplementKeys.sprayer },
    { text: VueI18n.t('views.missions.tillage') as string, value: ImplementKeys.tillage }
  ];
  static toolTypes = [
    { text: VueI18n.t('views.missions.weeder') as string, value: ImplementKeys.weeder },
    { text: VueI18n.t('views.missions.sprayer') as string, value: ImplementKeys.sprayer },
    { text: VueI18n.t('views.missions.disc') as string, value: ImplementKeys.disc },
    { text: VueI18n.t('views.missions.blade') as string, value: ImplementKeys.blade },
    { text: VueI18n.t('views.missions.mower') as string, value: ImplementKeys.mower },
    { text: VueI18n.t('views.missions.plough') as string, value: ImplementKeys.plough },
    { text: VueI18n.t('views.missions.none') as string, value: ImplementKeys.none }
  ];
}
